import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight16 = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("g", {
	fill: "none",
	fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0H16V16H0z",
	transform: "translate(-265 -330) translate(11 94) translate(16 220) translate(226 4) translate(12 12)"
}), /* @__PURE__ */ React.createElement("path", {
	stroke: "#888",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	d: "M10.5 3L5.5 8 10.5 13",
	transform: "translate(-265 -330) translate(11 94) translate(16 220) translate(226 4) translate(12 12) matrix(-1 0 0 1 16 0)"
}))))))));
const ForwardRef = forwardRef(SvgArrowRight16);
export default ForwardRef;
